<template>
    <div id="wrapper">
        <div class="row">
            <div class="col">
                <a class="navbar-brand" href="javascript:void(0)"><img src="@/assets/img/CAF_B_BLU.png" style="width:250px"></a>
            </div>
            
        </div>
        <div style="margin-bottom: 100px"></div>
        <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm" v-if="status == 'true'" style="border-style: solid; border-color: #008000;">
                <p style="color:#000000;font-size:28px;margin-top:10px;margin-bottom:10px">
                    Asseverazione autorizzata<br>
                </p>
            </div>
            <div v-else class="col-sm" style="border-style: solid; border-color: #FF0000;">
              <p style="color:#000000;font-size:28px;margin-top:10px;margin-bottom:10px">
                Asseverazione <i style="color:#FF0000; text-transform: uppercase">NON</i> autorizzata<br>
              </p>
          </div>
          <div class="col-sm"></div>
        </div> 
         <div style="margin-bottom: 100px"></div>
  </div>
</template>
<script>

export default {
  components: {},

  data() {
    return {
     status: false,
     id: null,
    };
  },
  methods: {},

  mounted() {
    this.status = this.$route.query.status
    this.id = this.$route.query.id
    console.log("status = "+this.status + ", id = "+ this.id)
  }
};
</script>
<style>
</style>
